export const bigHeroBlock = {
	title: `Пространство возможностей.`,
	description: `iPort - пространство, где люди, которые хотят реализовать свои цели и мечты, находят лучшие продукты, практики, сервисы и знания.`,
	imgSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/about-iport/iport-space.jpg`
}

export const factList = [
	{
		title: `27`,
		description: `Объектов в 9 городах России`
	},
	{
		title: `>1 млн.`,
		description: `Довольных клиентов`
	},
	{
		title: `>10`,
		description: `Лет на рынке`
	}
]

export const cityList = [
	`Санкт-Петербург`,
	`Архангельск`,
	`Казань`,
	`Москва`,
	`Мурманск`,
	`Нижневартовск`,
	`Новый Уренгой`,
	`Сургут`,
	`Ярославль`
]

export const practiceHorizontalSection = {
	title: `Мы обучаем креативным практикам.`,
	subtitle: `Получите вдохновение и научитесь использовать возможности техники и программ Apple на 100% в творческих мастер-классах Университета iPort, персональных обучениях и групповых занятиях.`
}

export const shopsSections = {
	title: `<span class="accent">27</span> магазинов и сервисных центров`
}

export const practiceImage = `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/about-iport/practice.png`

export const stepsItems = [
	{
		title: `Более 11 лет продаем и обслуживаем <br/> лучшую технику в своих категориях.`,
		subtitle: `Мы являемся одним из крупнейших Apple Premium Reseller в России. Также в наших магазинах продаются продукты ведущих мировых брендов и признанных лидеров рынка.`
	},
	{
		title: `Забота о технике <br/> по высшим стандартам`,
		subtitle: `Будьте спокойны за технику. Сервисные центры iPort гарантируют качество обслуживания и ремонта по признанным стандартам Apple.`
	},
	{
		title: `Индивидуальный <br/> подход.`,
		subtitle: `Персональные консультации, индивидуальные решения для личного использования, комплексный подход для бизнеса — это то, на чем основана наша ежедневная работа.`
	}
]

export const contrastInfoBlock = {
	title: `Наша миссия`,
	description: `Мы хотим, чтобы наши клиенты легко воплощали свои мечты и реализовывали поставленные задачи. Для этого мы создали пространство с лучшими продуктами, образовательными практиками и сервисом.`
}

export const companyDescription = `iPort входит в группу компаний NBCom Group, которая уже более 20 лет занимается развитием розничных и онлайн магазинов компьютерной и электронной техники. Группа компаний объединяет фирменные магазины Samsung, фирменные магазины Huawei, а также сервисные центры iPort и Samsung. Будем рады видеть вас среди наших клиентов и партнеров!`
export const heroBannerData = {
	image: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/about-iport/heroBanner-min.jpg',
	text: 'iPort — пространство, где люди, которые хотят реализовать свои цели и мечты, находят лучшие продукты, практики, сервисы и знания',
	title: 'Пространство возможностей',
	additional: [
		{
			title: '19',
			text: 'Обьектов в 6 городах России'
		},
		{
			title: '>1 млн.',
			text: 'Довольных клиентов'
		},
		{
			title: '>14',
			text: 'Лет на рынке'
		}
	]
}
export const aboutInfoData = [
	{
		title: 'Более 14 лет продаем и обслуживаем лучшую технику в своих категориях',
		subtitle:
			'Мы являемся одним из крупнейших Apple Premium Reseller в России. Так же в наших магазинах продаются продукты ведущих мировых брендов и признанных лидеров рынка.',
		img: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/about-iport/infoBlock/first-min.png'
	},
	{
		title: 'Забота о технике по высшим стандартам',
		subtitle:
			'Будьте спокойны за технику. Наши сервисные центры iPort гарантируют качество обслуживания и ремонта по признанным стандартам Apple.',
		img: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/about-iport/infoBlock/second-min.png'
	},
	{
		title: 'Индивидуальный подход',
		subtitle:
			'Персональные консультации, индивидуальные решения для личного использования, комплексный подход для бизнеса — это то, на чем основана наша ежедневная работа.',
		img: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/about-iport/infoBlock/third-min.png'
	},
	{
		title: 'Обучаем креативным практикам',
		subtitle:
			'Получите вдохновение и научитесь использовать возможности техники и программ на 100% в творческих мастер-классах Университета iPort, персональных обучениях, групповые занятиях.',
		img: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/about-iport/infoBlock/fourth-min.png'
	}
]
